<template>
        <div class="sharebarcode_bg">
          <div class="sharecode-content">
              <div class="sharecode-row1">
                  <div class="sharecode-row1-bg">
                      <img src="~@/assets/img/zmbg.jpg" class='zmbg'/>
                  </div>
                  <div class="sharecode-row1-content">
                      <div class="sharecode-row1-col1">
                            <img src="~@/assets/img/zmlogo.png" class='zmimg'/> 
                      </div>
                      <div class="sharecode-row1-col2">
                            <div class="sharecode-r1c2-left">
                                <div class="sharecode-username">{{username}}</div>
                                <div class="sharecode-mobile">{{mobile}}</div>
                            </div>
                            <div class='sharecode-r1c2-right'>
                                <img :src="headimg"  class='sharecode-headimg'/>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="sharecode-row2">
                    <img :src="qrcode" class='sharecode-r2-img'/>
              </div>
              <div class="sharecode-row3">
                  <div class="sharecode-r3-spliterout"><div class="sharecode-r3-spliter"></div></div>
                  <div class="sharecode-r3-txt">正品保证</div>
                  <div class="sharecode-r3-spliterout"><div class="sharecode-r3-spliter"></div></div>
              </div>
          </div>
      </div>
</template>

<script>
export default {
  name: 'ShareImg',
  props: {
    username:String,
    mobile:String,
    headimg:String,
    qrcode:String
  }
}
</script>
<style scoped>
.sharebarcode_bg{display: flex;position: fixed;width:100%;height: calc( 100vh - 4rem );z-index:9999;align-items: center;justify-content: center;background-color: transparent;left:0;top:0;flex-flow: column nowrap;}
.sharecode-row1{display: flex;width:100%;flex-flow: row nowrap;align-items: center;position: relative;height:2.8rem;}
.sharecode-row1-col1{width:50%;}
.zmimg{width:2.3rem;height:2rem;}
.sharecode-row1-col2{width:50%;display: flex;flex-flow: row nowrap;align-items: center;}
.sharecode-r1c2-left{display: flex;flex-flow: column nowrap;justify-content: center;align-items: flex-end;}
.sharecode-username{font-size:0.3rem;color:#3B4B99;font-size:0.40rem;}
.sharecode-mobile{font-size:0.25rem;color:#3B4B99;font-size:0.35rem;margin-top: 0.15rem;}
.sharecode-headimg{border-radius: 50%;width:1.5rem;height:1.5rem;}
.sharecode-row2{display: flex;width:100%;flex-flow: row nowrap;align-items: center;justify-content: center;width:100%;margin-top:0.32rem;}
.sharecode-r2-img{width:6rem;height:6rem;}
.sharecode-row3{display: flex;flex-flow: row nowrap;align-items: center;width:100%;height:1.2rem;padding: 0 0.6rem;}
.sharecode-r3-spliterout{flex:1;}
.sharecode-r3-spliter{width:100%;height: 1px;background-color: #ccc;border: none;}
.sharecode-r3-txt{flex:1;color:#000;font-size: 0.30rem;}
.sharecode-row1-bg{position: absolute;width:100%;height:100%;z-index:995;}
.sharecode-row1-content{padding: 0.25rem 0;z-index:996;width:100%;display: flex;flex-flow: row nowrap;align-items: center;}
.zmbg{width:100%;height:2.8rem;border-top-left-radius: 0.15rem;border-top-right-radius: 0.15rem}
.sharecode-content{width:85%;background-color: #fff;border-radius: 0.15rem;}
.sharecode-r1c2-right{margin-left:0.2rem;}
</style>


